<script setup>
import IconClose from "../../common/components/icons/IconClose.vue";
import { ref } from "vue";

const steps = ref([
  {
    title: "Estimez le montant de votre prime",
    description: "Avant d'engager vos travaux, estimez le montant de votre prime.",
    description_pro: "Avant d'engager vos travaux, estimez le montant de votre prime.",
    color: "#00b2d0",
  },
  {
      title: "Constituez et envoyez-nous votre dossier complet",
      description: "Choisissez un artisan RGE pour vos travaux. Une fois vos travaux r&eacute;alis&eacute;s, constituez votre dossier avec lui et envoyez-nous votre dossier complet.",
      description_pro: "Une fois vos travaux r&eacute;alis&eacute;s, constituez et envoyez-nous votre dossier complet.",
      color: "#f39200",
  },
  {
      title: "Recevez votre prime en euros",
      description: "D&egrave;s validation d&eacute;finitive de votre dossier, recevez votre paiement en euros.",
      description_pro: "D&egrave;s validation d&eacute;finitive de votre dossier, recevez votre paiement en euros.",
      color: "#f30057",
  }
])

function scrollToTabPrime() {
    this.$el.scrollIntoView();
    // Scroll top to offset the height of the header, which has position: absolute.
    window.scrollBy(0, 0 - document.querySelector('.page-header').offsetHeight);
}
function closeStickyAnchor(element) {
    this.$el.querySelector('.tab-prime--anchor').remove();
}
</script>

<style lang="sass">
    @import ../../common/styles/settings
    @import ../../common/styles/mixins

    .paragraph--type--tab-prime
        padding-top: 2rem !important
        padding-bottom: 2rem !important
        text-align: center

        .tab-prime--steps
            +media('>=768px')
                display: flex
                flex-direction: row
                justify-content: space-between

            .tab-prime--step
                box-sizing: border-box
                background: white
                border-radius: 0.5rem
                padding: 1.25rem
                text-align: left

                +media('>=768px')
                    flex: 0 0 calc((100% - 4rem) / 3)

                &:not(:last-child)
                    +media('<768px')
                        margin-bottom: 1rem
                    +media('>=768px')
                        margin-right: 2rem

                .step-number
                    display: inline-block
                    border-radius: 50%
                    width: 2.625rem
                    height: 2.625rem
                    font-size: 1.25rem
                    line-height: 2.625rem
                    color: white
                    text-align: center
                    font-weight: 600

                .step-title
                    margin-top: 1.5rem
                    font-weight: 600

                .step-description
                    margin-top: 1rem

        .paragraph--type--title-description-buttons
            border-radius: 0.5rem
            background: white
            margin-top: 1.5rem
            padding: 2rem

            .title-description-buttons
                &--title
                    font-weight: 600

                &--description
                    margin-top: 0.5rem

                &--buttons
                    margin-top: 1rem
                    display: flex
                    flex-direction: row
                    justify-content: space-evenly
                    align-items: center

                    flex-wrap: wrap

                    +media('<768px')
                        flex-direction: column

                    .button
                        margin-top: 0.5rem

        .tab-prime--anchor
            position: fixed
            bottom: 20%
            right: 0
            z-index: 2
            display: flex
            align-items: center
            border-radius: 0.5rem 0 0 0.5rem
            padding: 1rem 1.5rem 1rem 1rem
            background: white
            box-shadow: $card-shadow

            img
                height: 60px
                margin-right: 1rem

            .button
                letter-spacing: 0
                padding: 0.75rem 2rem

            +media('<768px')
                padding: 0.75rem 1rem 0.75rem 0.5rem

                img
                    height: 40px

                .button
                    padding: 0.5rem 1.5rem
                    font-size: 0.75rem

            &--close
                position: absolute
                bottom: 100%
                right: 0
                background: white
                border-top-left-radius: 0.5rem
                border-top: 1px solid rgba(0, 0, 0, 0.15)
                border-left: 1px solid rgba(0, 0, 0, 0.15)
                padding: 0.5rem
                cursor: pointer

                svg
                    display: flex

</style>
